import { createAction } from 'redux-actions';
export const SET_PAYMENT_STATUS = 'EXCHANGE/SET_PAYMENT_STATUS';
export const CLEAR_PAYMENT_STATUS = 'EXCHANGE/CLEAR_PAYMENT_STATUS';
export const setPaymentStatus = createAction(SET_PAYMENT_STATUS);
export const clearPaymentStatus = createAction(CLEAR_PAYMENT_STATUS);
